import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from '@8base-react/auth';

import { APP_URL, useBuildUrl } from 'common/routing';
import { useQueryParams } from 'utils/hooks';

export const OrganizationInviteContainer = () => {
  const [queryParams] = useQueryParams();
  const auth = useAuth();
  const buildUrl = useBuildUrl();

  if (!queryParams.id) {
    return <Redirect to={ buildUrl(APP_URL.inviteIncorrect) } />;
  }

  window.trackEvent('System', 'Accept organization invite');

  if (auth.isAuthorized) {
    const url = buildUrl(APP_URL.developerHomeWorkspaces, { queryParams: { organization_invite_id: queryParams.id }});

    return <Redirect to={ url } />;
  }


  return <Redirect to={ buildUrl(APP_URL.authSignup) } />;
};
